import { Components } from '@/api/generated/api';
import { now } from 'common/utils/date.utils';

export function createFakeUserFromInvitation(invitationId: number, email = ''): Components.Schemas.UserDataDto {
  return {
    id: invitationId,
    email,
    firstName: '',
    lastName: '',
    source: null,
    sourceOther: null,
    avatar: null,
    avatarPictureId: null,
    isSetupCompleted: false,
    createdAt: now().toISOString(),
    updatedAt: now().toISOString(),
    isApproved: false,
    countryId: null,
    stateId: null,
    demoClassWizardSeen: false,
    ratingDialogSeenAt: null,
    weeklyReportActive: false,
    deactivatedAt: null,
    language: null,
  };
}

export function maskEmail(email: string | null | undefined): string {
  if (!email) return '';

  const [local, domain] = email.split('@');
  if (!domain) return email;

  const visibleLocal = local.slice(0, 3) || local;

  const domainParts = domain.split('.');
  const tld = domainParts.length > 1 ? domainParts[domainParts.length - 1] : '';
  const suffix = tld ? `.${tld}` : '';

  return `${visibleLocal}********${suffix}`;
}
